export const getAdultsCount = (travellers) => travellers && travellers.adults;

const getTravellersCount = (travellers) =>
  ['adults', 'children', 'infants']
    .map((key) => travellers[key])
    .map(parseFloat)
    .reduce((a, b) => a + b, 0);

export default getTravellersCount;
